module.exports = __webpack_public_path__ + "static/media/react.76c262d3.png";